// extracted by mini-css-extract-plugin
module.exports = {"tooltipWrapper":"CopyToClipboardButton-tooltipWrapper-2PLnk4"};